module.exports = __webpack_public_path__ + "img/portfolio.3ff03304.svg";